<template>
	<v-flex mb-4>
		<documents-display-toolbar
			:type="type"
			:filterable="false"
			@sort="filterAndSort"
			@filter="filterAndSort"
			:title="title"
			ref="DocumentsDisplayToolbar"
		></documents-display-toolbar>

		<v-layout row :wrap="this.$vuetify.breakpoint.mdAndDown">
			<slot name="summary"></slot>

			<v-flex sm12 :lg9="!isGrid" :lg12="privacy" class="documents-display__cards">
				<transition-group
					name="cards"
					class="layout wrap card-list"
					:class="isGrid ? 'card-list--grid' : 'card-list--slider'"
					tag="div"
					appear
				>
					<v-flex
						xs12
						sm6
						md4
						:lg3="isGrid || privacy"
						grow
						v-for="document in documents"
						:key="document.id"
					>
						<document-card :document="document"></document-card>
					</v-flex>
				</transition-group>

				<div class="pagination" :class="isGrid ? 'pagination--grid' : 'pagination--slider'">
					<v-pagination v-model="pagination.page" :length="pages" v-if="pages > 1"></v-pagination>
				</div>
			</v-flex>
		</v-layout>
	</v-flex>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import DocumentsDisplayToolbar from "@components/partials/DocumentsDisplayToolbar";
import DocumentCard from "@components/partials/DocumentCard";
import Pagination from "@components/partials/Pagination";

export default {
	data: () => ({
		sort_options: [],
		page: 0,
		filters: null,
		pagination: {
			page: 1
		}
	}),

	components: { DocumentCard, DocumentsDisplayToolbar, Pagination },

	props: {
		title: {
			default: ""
		},

		type: {
			default: "Quotes"
		},

		grid: {
			default: false
		},

		displayQty: {
			default: 3
		}
	},

	computed: {
		...mapGetters(["dark", "privacy", "searchQuery"]),

		...mapGetters("documents", {
			GET_DOCUMENTS: "documents",
			TOTAL_DOCUMENT_PAGES: "totalDocumentPages"
		}),

		singularType() {
			return this.type === "Quotes" ? "Quote" : "Order";
		},

		isGrid() {
			return this.grid;
		},

		documents() {
			let documents = this.GET_DOCUMENTS(
				this.singularType.toLowerCase(),
				this.filters,
				this.displayQty,
				this.pagination.page - 1,
				false,
				this.searchQuery
			);

			if (documents === null) {
				return [];
			}

			return documents;
		},

		pages() {
			return this.TOTAL_DOCUMENT_PAGES(
				this.singularType.toLowerCase(),
				this.displayQty,
				this.filters,
				this.searchQuery
			);
		}
	},

	methods: {
		filterAndSort(params) {
			this.$set(this, "filters", Object.assign({}, params));
		},

		filterNotSent() {
			this.$refs.DocumentsDisplayToolbar.filterNotSent();
		}
	}
};
</script>
